// COMPANY, REGION, AND GROUP ROUTES

const crgLevel = ["company", "region", "group", "dealer"];
const companyLevel = ["company"];

const priceMgtRoute = {
  route: "Price management",
  path: "",
  routeIcon: "money-recive.svg",
  activeRouteIcon: "money-recive-active.svg",
  children: [
    {
      route: "Price Log",
      path: "/price-log",
    },

    {
      route: "Price change status",
      path: "/price-change-status",
    },

    {
      route: "Price approval",
      path: "/price-approval",

      roles: [
        "ApprovePrice",
        "CompanyApproval",
        "BranchApproval",
        "GroupApproval",
      ],
    },

    // {
    //   route: "Manage approval",
    //   path: "/manage-approval",

    //   roles: [
    //     "ApprovePrice",
    //     "CompanyApproval",
    //     "BranchApproval",
    //     "GroupApproval",
    //   ],
    // },
  ],
  name: [
    "price-log",
    "price-change-status",
    "price-approval",
    "price-approval-details",
    "price-log-breakdown",
  ],
  view: ["station"],
  levels: crgLevel,
  roles: [
    "Price",
    "ApprovePrice",
    "CompanyPrice",
    "BranchPrice",
    "GroupPrice",
    "CompanyApproval",
    "BranchApproval",
    "GroupApproval",
  ],
};

const pumpMgt = {
  route: "Pump management",
  path: "",
  routeIcon: "gas-station.svg",
  activeRouteIcon: "active-gas-station.svg",
  children: [
    {
      route: "Shutdown Pump",
      path: "/shutdown-pump",
    },

    {
      route: "Pump Calibration",
      path: "/pump-calibration",
    },
  ],
  name: ["pump-calibration", "shutdown-pump"],
  view: ["station"],
  levels: crgLevel,
  roles: [
    "Price",
    "ApprovePrice",
    "CompanyPrice",
    "BranchPrice",
    "GroupPrice",
    "CompanyApproval",
    "BranchApproval",
    "GroupApproval",
  ],
};

const stations = {
  route: "Stations",
  path: "/stations",
  routeIcon: "buildings-2.svg",
  activeRouteIcon: "station(active).svg",
  children: [],
  name: ["stations", "station-dashboard"],
  view: [
    "station",
    "staffManangement",
    "stationLease",
    "maintenance",
    "remis",
    "drystock",
  ],
  levels: crgLevel,

  roles: ["ViewOutlet"],
};

const companyReports = [
  {
    route: "Cashflow",
    path: "/cashflow",
    routeIcon: "dollar-circle@2x.svg",
    activeRouteIcon: "active-dollar-circle.png",
    name: ["cashflow"],
    children: [],
    view: ["station"],
    levels: crgLevel,
    roles: ["Account", "Report"],
  },

  {
    route: "Sales report",
    path: "",
    routeIcon: "inactive-globe-alt.svg",
    activeRouteIcon: "globe-alt.svg",

    children: [
      {
        route: "Station sales ",
        path: "/station-sales",
        roles: ["Report", "StationSales", "SalesReport", "Transactions"],
      },
      {
        route: "Pump variance ",
        path: "/pump-variance",
        roles: ["Report", "PumpVariance", "SalesReport"],
      },
      {
        route: "Tank variance ",
        path: "/tank-variance",
        roles: ["Report", "TankVariance", "SalesReport"],
      },
      {
        route: "POS sales",
        path: "/pos-sales",
        roles: ["Report", "TankVariance", "SalesReport"],
      },
      {
        route: "Remis sales",
        path: "/remis-sales",
        roles: ["Report", "TankVariance", "SalesReport"],
      },

      {
        route: "Retainership Sales",
        path: "/retainership-sales",
        roles: ["Report", "SalesReport"],
      },
      {
        route: "Wallet",
        path: "/remis/wallet",
        roles: ["Report", "SalesReport"],
      },
      {
        route: "Remis Fueling",
        path: "/remis/fueling",
        roles: ["Report", "SalesReport"],
      },
    ],
    name: [
      "sales-report",
      "station-sales",
      "station-sales-transactions",
      "tank-variance",
      "station-tank-variance",
      "pump-variance",
      "station-pump-variance",
      "remis-sales",
      "remis-sales-details",
      "remis-company-wallet",
      "remis-company-wallet",
      "pos-sales",
      "retainership-sales-details",
      "retainership-sales",
      "remis-fueling",
      "remis-fueling-details",
      "remis-wallet",
    ],
    view: ["station"],
    levels: crgLevel,
    roles: [
      "Report",
      "SalesReport",
      "StationSales",
      "PumpVariance",
      "TankVariance",
      "Transactions",
      //       view: [],
    ],
  },

  {
    route: "Inventory report",
    path: "",
    routeIcon: "inactive-receipt-2.svg",
    activeRouteIcon: "receipt-2.svg",
    children: [
      {
        route: "Product stock ",
        path: "/product-stock",
        roles: ["Report", "InventoryReport", "ProductStock"],
      },
      {
        route: "Product discharged ",
        path: "/product-discharged",
        roles: ["Report", "InventoryReport", "ProductDischarged"],
      },
      {
        route: "Stock valuation",
        path: "/stock-valuation",
        roles: ["Report", "InventoryReport", "StockValuation"],
      },

      {
        route: "Suffciency metrics",
        path: "/sufficiency-metrics",
        roles: ["Report", "InventoryReport", "SufficiencyMetrics"],
      },
      {
        route: "Product monitoring",
        path: "/company-product-inventory",
        companyCheck: true,
        roles: ["Report", "InventoryReport", "ProductMonitoring"],
      },
      {
        route: "Send branch report",
        path: "/branch-reports",
        roles: ["Report", "InventoryReport"],
      },
    ],
    name: [
      "product-stock",
      "product-discharged",
      "stock-valuation",
      "product-received",
      "inventory-sales",
      "inventory-supply",
      "company-product-inventory",
    ],
    view: ["station"],
    levels: crgLevel,
    roles: [
      "Report",
      "InventoryReport",
      "ProductStock",
      "ProductDischarged",
      "StockValuation",
      "SufficiencyMetrics",
      "ProductMonitoring",
    ],
  },
  {
    route: "Transactions",
    path: "/transactions",
    routeIcon: "moneys.svg",
    activeRouteIcon: "moneys-active.svg",
    children: [],
    name: ["transactions"],
    levels: companyLevel,
    roles: ["Report", "SalesReport", "Transactions"],
    view: ["station"],
  },
];

// 🚨 Reports grouped under one roof

// const companyReports = {
//   route: "Reports",
//   path: "/reports",
//   routeIcon: "dollar-circle@2x.svg",
//   activeRouteIcon: "active-dollar-circle.png",
//   name: ["cashflow"],
//   children: [
//     {
//       route: "Cashflow",
//       path: "/cashflow",
//       // routeIcon: "dollar-circle@2x.svg",
//       // activeRouteIcon: "active-dollar-circle.png",
//       name: ["cashflow"],
//       children: [],
//       view: ["station"],
//       levels: crgLevel,
//       roles: ["Account", "Report"],
//     },

//     {
//       route: "Transactions",
//       path: "/transactions",
//       routeIcon: "moneys.svg",
//       activeRouteIcon: "moneys-active.svg",
//       children: [],
//       name: ["transactions"],
//       levels: companyLevel,
//       roles: ["Report", "SalesReport", "Transactions"],
//       view: ["station"],
//     },

//     {
//       route: "Sales report",
//       path: "",
//       // routeIcon: "inactive-globe-alt.svg",
//       // activeRouteIcon: "globe-alt.svg",

//       children: [
//         {
//           route: "Station sales ",
//           path: "/station-sales",
//           roles: ["Report", "StationSales", "SalesReport", "Transactions"],
//         },
//         {
//           route: "Pump variance ",
//           path: "/pump-variance",
//           roles: ["Report", "PumpVariance", "SalesReport"],
//         },
//         {
//           route: "Tank variance ",
//           path: "/tank-variance",
//           roles: ["Report", "TankVariance", "SalesReport"],
//         },
//         {
//           route: "POS sales",
//           path: "/pos-sales",
//           roles: ["Report", "TankVariance", "SalesReport"],
//         },
//         {
//           route: "Remis sales",
//           path: "/remis-sales",
//           roles: ["Report", "TankVariance", "SalesReport"],
//         },
//       ],
//       name: [
//         "sales-report",
//         "station-sales",
//         "station-sales-transactions",
//         "tank-variance",
//         "station-tank-variance",
//         "pump-variance",
//         "station-pump-variance",
//         "remis-sales",
//         "remis-sales-details",
//         "remis-company-wallet",
//         "remis-company-wallet",
//         "pos-sales",
//       ],
//       view: ["station"],
//       levels: crgLevel,
//       roles: [
//         "Report",
//         "SalesReport",
//         "StationSales",
//         "PumpVariance",
//         "TankVariance",
//         "Transactions",
//         //       view: [],
//       ],
//     },

//     {
//       route: "Inventory report",
//       path: "",
//       // routeIcon: "inactive-receipt-2.svg",
//       // activeRouteIcon: "receipt-2.svg",
//       children: [
//         {
//           route: "Product stock ",
//           path: "/product-stock",
//           roles: ["Report", "InventoryReport", "ProductStock"],
//         },
//         {
//           route: "Product discharged ",
//           path: "/product-discharged",
//           roles: ["Report", "InventoryReport", "ProductDischarged"],
//         },
//         {
//           route: "Stock valuation",
//           path: "/stock-valuation",
//           roles: ["Report", "InventoryReport", "StockValuation"],
//         },

//         {
//           route: "Suffciency metrics",
//           path: "/sufficiency-metrics",
//           roles: ["Report", "InventoryReport", "SufficiencyMetrics"],
//         },
//         {
//           route: "Product monitoring",
//           path: "/company-product-inventory",
//           companyCheck: true,
//           roles: ["Report", "InventoryReport", "ProductMonitoring"],
//         },
//         {
//           route: "Send branch report",
//           path: "/branch-reports",
//           roles: ["Report", "InventoryReport"],
//         },
//       ],
//       name: [
//         "product-stock",
//         "product-discharged",
//         "stock-valuation",
//         "product-received",
//         "inventory-sales",
//         "inventory-supply",
//         "company-product-inventory",
//       ],
//       view: ["station"],
//       levels: crgLevel,
//       roles: [
//         "Report",
//         "InventoryReport",
//         "ProductStock",
//         "ProductDischarged",
//         "StockValuation",
//         "SufficiencyMetrics",
//         "ProductMonitoring",
//       ],
//     },
//   ],
//   view: ["station"],
//   levels: crgLevel,
//   roles: ["Account", "Report"],
// };

// 🚨 Drystock Module navigations

// const drystock = {
//   route: "Dry stock",
//   path: "",
//   routeIcon: "shopping-cart.svg",
//   activeRouteIcon: "active-shopping-cart.svg",
//   children: [
//     {
//       route: "Product",
//       path: "/dry-stock-product",
//     },
//     {
//       route: "Supply",
//       path: "/dry-stock-supply",
//     },
//     {
//       route: "Sales",
//       path: "/dry-stock-sales",
//     },
//     {
//       route: "Station product stock",
//       path: "/branch-product-stock",
//     },
//     {
//       route: "Product category",
//       path: "/dry-stock-product-cat",
//     },
//   ],
//   name: [
//     "dry-stock",
//     "dry-stock-product", ,
//     "drystock-single-product",

//     "dry-stock-supply",
//     "dry-stock-stock-supply",
//     "dry-stock-supply-details",

//     "dry-stock-sales",
//     "dry-stock-sales-details",

//     "dry-stock-product-cat"

//     "dry-stock-stock",
//     "dry-stock-stock-sale",
//   ],
//   view: ["drystock"],
//   levels: companyLevel,
//   roles: ["canmanagedrystock", "viewdrystockproducts"],
// };

const drystockProduct = {
  route: "Product",
  path: "/dry-stock-product",
  routeIcon: "box.svg",
  activeRouteIcon: "active-box.svg",
  children: [],
  name: ["dry-stock-product", "drystock-single-product"],
  view: ["drystock"],
  levels: companyLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts"],
};

const drystockSupply = {
  route: "Supply",
  path: "/dry-stock-supply",
  routeIcon: "grey-send-sqaure-2.svg",
  activeRouteIcon: "green-send-sqaure-2.svg",
  children: [],
  name: [
    "dry-stock-supply",
    "dry-stock-stock-supply",
    "dry-stock-supply-details",
  ],
  view: ["drystock"],
  levels: companyLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts"],
};

const drystockSales = {
  route: "Sales",
  path: "/dry-stock-sales",
  routeIcon: "money-recive.svg",
  activeRouteIcon: "active-money-recive.svg",
  children: [],
  name: ["dry-stock-sales", "dry-stock-sales-details"],
  view: ["drystock"],
  levels: companyLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts"],
};

const drystockStationProductStock = {
  route: "Station product stock",
  path: "/branch-product-stock",
  routeIcon: "notification-bing.svg",
  activeRouteIcon: "green-notification-bing.svg",
  children: [],
  name: ["dry-stock-stock", "dry-stock-stock-sale"],
  view: ["drystock"],
  levels: companyLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts"],
};

const drystockProductCategory = {
  route: "Product category",
  path: "/dry-stock-product-cat",
  routeIcon: "box-add.svg",
  activeRouteIcon: "green-box-add.svg",
  children: [],
  name: ["dry-stock-product-cat"],
  view: ["drystock"],
  levels: companyLevel,
  roles: ["canmanagedrystock", "viewdrystockproducts"],
};

//

// 🚨 Remis module navigation
// const remis = {
//   route: "Remis(payment)",
//   path: "",
//   routeIcon: "remis-icon.svg",
//   activeRouteIcon: "active-remis-icon.svg",
//   children: [
//     {
//       route: "Retainership",
//       path: "/remis/retainership",
//       roles: ["ManageRemis", "Retainership"],
//     },
//     {
//       route: "Wallet top-up requests",
//       path: "/remis/wallet-topup-requests",
//       roles: ["ManageRemis", "Retainership"],
//     },
//     {
//       route: "Card management",
//       path: "/remis/card-management",
//       roles: ["ManageRemis", "Retainership"],
//     },
//     {
//       route: "Loyalty",
//       path: "/remis/loyalty",
//       roles: ["ManageRemis", "Loyalty"],
//     },
//     {
//       route: "POS",
//       path: "/remis/pos",
//       roles: ["ManageRemis", "POS"],
//     },
//     {
//       route: "Wallet",
//       path: "/remis/wallet",
//       roles: ["ManageRemis", "RemisWallet"],
//     },
//     {
//       route: "Remis Fueling",
//       path: "/remis/fueling",
//       roles: ["ManageRemis", "RemisFueling"],
//     },
//   ],
//   name: [
//     "remis-loyalty",
//     "loyalty-details",
//     "remis-pos",
//     "remis-pos-transaction",
//     "remis-fueling",
//     "remis-fueling-details",
//     "remis-retainership",
//     "remis-wallet",
//   ],
//   view: ["remis"],
//   levels: companyLevel,
//   roles: [
//     "ManageRemis",
//     "Retainership",
//     "Loyalty",
//     "POS",
//     "RemisWallet",
//     "RemisFueling",
//   ],
// };

const Retainership = {
  route: "Retainership",
  path: "/remis/retainership",
  routeIcon: "gift.svg",
  activeRouteIcon: "green-gift.svg",
  children: [],
  name: ["remis-retainership", "remis-retainership-transaction-history"],
  view: ["remis"],
  levels: companyLevel,
  roles: ["ManageRemis", "Retainership"],
};

const WalletTopup = {
  route: "Wallet top-up requests",
  path: "/remis/wallet-topup-requests",
  routeIcon: "wallet-add.svg",
  activeRouteIcon: "green-wallet-add.svg",
  children: [],
  name: ["wallet-topup-requests"],
  view: ["remis"],
  levels: companyLevel,
  roles: ["ManageRemis", "Retainership"],
};

const CardMgt = {
  route: "Card management",
  path: "/remis/card-management",
  routeIcon: "card.svg",
  activeRouteIcon: "green-card.svg",
  children: [],
  name: ["remis-card-management"],
  view: ["remis"],
  levels: companyLevel,
  roles: ["ManageRemis", "Retainership"],
};

const Loyalty = {
  route: "Loyalty",
  path: "/remis/loyalty",
  routeIcon: "notification-bing.svg",
  activeRouteIcon: "green-notification-bing.svg",
  children: [],
  name: ["remis-loyalty", "loyalty-details"],
  view: ["remis"],
  levels: companyLevel,
  roles: ["ManageRemis", "Loyalty"],
};

const invoice = {
  route: "Invoice",
  path: "/invoice",
  routeIcon: "invoice.svg",
  activeRouteIcon: "document.svg",
  children: [],
  name: ["invoice", "invoice-details", "invoice-payment-history"],
  view: ["station"],
  levels: companyLevel,
  roles: ["Account"],
};
const bankDeposit = {
  route: "Bank Deposit",
  path: "/bank-deposit",
  routeIcon: "money-add.svg",
  activeRouteIcon: "active-money-add.svg",
  children: [],
  name: ["bank-deposit"],
  view: ["station"],
  levels: companyLevel,
  roles: ["ManageBankDeposit"],
};

// 🚨 Staff management
// const staffMgt = {
//   route: "Staff Management",
//   path: "/staff-management",
//   routeIcon: "profile-2user.svg",
//   activeRouteIcon: "profile-2user--filled.svg",
//   children: [
//     {
//       route: "List of staff",
//       path: "/company-staff-list",
//     },

//     {
//       route: "Performance evaluation",
//       path: "/performance-evaluation",
//     },

//     {
//       route: "Staff comparison",
//       path: "/staff-comparison",
//     },
//   ],
//   name: [
//     "staff-management",
//     "leave-management",
//     "salary-management",
//     "company-staff-list",
//     "performance-evaluation",
//   ],
//   levels: companyLevel,
//   roles: ["ManageStaff"],
//   view: ["staffManangement"],
// };

const staffList = {
  route: "Staff list",
  path: "/company-staff-list",
  routeIcon: "profile-2user.svg",
  activeRouteIcon: "profile-2user--filled.svg",
  children: [],
  name: ["company-staff-list"],
  levels: companyLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

const PerformanceEval = {
  route: "Performance evaluation",
  path: "/performance-evaluation",
  routeIcon: "grey-status-up.svg",
  activeRouteIcon: "green-status-up.svg",
  children: [],
  name: ["performance-evaluation"],
  levels: companyLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

const StaffComparison = {
  route: "Staff comparison",
  path: "/staff-comparison",
  routeIcon: "grey-status-up.svg",
  activeRouteIcon: "green-status-up.svg",
  children: [],
  name: ["staff-comparison"],
  levels: companyLevel,
  roles: ["ManageStaff"],
  view: ["staffManangement"],
};

//

const region = {
  route: "Region",
  path: "/region",
  routeIcon: "map.svg",
  activeRouteIcon: "active-map.svg",
  children: [],
  name: ["region"],
  view: ["station"],
  levels: companyLevel,
  roles: ["AddGroup", "ViewGroups"],
};

const groups = {
  route: "Groups",
  path: "/groups",
  routeIcon: "rectangle-group.svg",
  activeRouteIcon: "rectangle-group--filled.svg",
  children: [],
  name: ["groups"],
  view: ["station"],
  levels: companyLevel,
  roles: ["AddGroup", "ViewGroups"],
};

const alertAlarm = {
  route: "Alert and Alarm",
  path: "/alert-alarm",
  routeIcon: "bell-alert.svg",
  activeRouteIcon: "bell-alert-active.svg",
  children: [],
  name: ["alertAlarm"],
  view: ["maintenance"],
  levels: companyLevel,
  roles: ["Maintenance", "ManageMaintenance", "ViewMaintenance"],
};

const equipmentReport = {
  route: "Equipment Report",
  path: "",
  routeIcon: "receipt-edit.svg",
  activeRouteIcon: "green-receipt-edit.svg",
  children: [
    {
      route: "Overview report",
      path: "/equipment-report",
      // roles: ["Maintenance", "ManageMaintenance", "ViewMaintenance"],
    },
    {
      route: "Equipment breakdown",
      path: "/equipment-breakdown",
    },
    {
      route: "Station missing data",
      path: "/station-missing-data",
    },
    {
      route: "All Equipments",
      path: "/all-equipments",
    },
  ],
  name: [
    "equipment-report",
    "station-missing-data",
    "equipment-breakdown",
    "station-missing-data",
    "all-equipments",
  ],
  view: ["maintenance"],
  levels: crgLevel,
  roles: ["Maintenance", "ManageMaintenance", "ViewMaintenance"],
};

const assetMgt = {
  route: "Asset management",
  path: "",
  routeIcon: "inactive-assetMgt.svg",
  activeRouteIcon: "active-assetMgt.svg",
  children: [
    {
      route: "Asset List",
      path: "/assets",
    },

    {
      route: "Asset Upload History",
      path: "/asset-upload-history",
    },
  ],
  name: [
    "assets",
    "category-asset",
    "station-asset",
    "asset-details",
    "asset-upload-history",
  ],
  view: ["maintenance"],
  levels: crgLevel,
  roles: ["viewAsset", "ManageAsset"],
};

const services = {
  route: "Services ",
  path: "/services",
  routeIcon: "category-2.svg",
  activeRouteIcon: "category-2-active.svg",
  children: [],
  name: ["services"],
  view: ["stationLease"],
  levels: companyLevel,
  roles: ["Service"],
};

const servicesTransactions = {
  route: "Transactions ",
  path: "/services-transactions",
  routeIcon: "money-add.svg",
  activeRouteIcon: "money-add-green.svg",
  children: [],
  name: ["services-transaction", "services-transactions"],
  view: ["stationLease"],
  levels: companyLevel,
  roles: ["Service"],
};

export const CRGroutes = [
  priceMgtRoute,
  stations,
  ...companyReports,
  pumpMgt,

  // 🚨 Drystock
  drystockProduct,
  drystockSupply,
  drystockSales,
  drystockStationProductStock,
  drystockProductCategory,

  // 🚨 Remis
  Retainership,
  WalletTopup,
  CardMgt,
  Loyalty,

  // 🚨 Staff mgt
  staffList,
  StaffComparison,
  PerformanceEval,

  equipmentReport,

  invoice,
  bankDeposit,
  region,
  groups,

  // 🚨 SERVICES
  services,
  servicesTransactions,

  assetMgt,
  alertAlarm,
];
